"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    chillCumulativeHoursBelow45FMAR: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativeHoursBelow45FMAY: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativeHoursBelow45FNOV: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativeHoursBelow45FSEP: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativeHoursBetween32and45FMAR: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativeHoursBetween32and45FMAY: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativeHoursBetween32and45FNOV: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativeHoursBetween32and45FSEP: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativePortionsMAR: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativePortionsMAY: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativePortionsNOV: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillCumulativePortionsSEP: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillHoursBelow45F: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillHoursBetween32and45F: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    chillPortions: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=chill.js.map